import React from 'react';
import { MessageCircle, Phone, Star } from 'lucide-react';
import { CHAT_CONSULTATION_PRICE, CALL_CONSULTATION_PRICE, PREMIUM_SESSION_PRICE } from '../../constants/pricing';
import { openWhatsApp } from '../../lib/whatsapp';
import { ConsultationCard } from './ConsultationCard';

const consultationServices = [
  {
    id: 1,
    title: 'Chat Consultation',
    duration: '30 Minutes',
    price: CHAT_CONSULTATION_PRICE,
    icon: MessageCircle,
    description: 'Quick and convenient chat session for your urgent questions. Get clear guidance through text.',
    features: ['Instant Responses', 'Life Predictions', 'Personalized Remedies'],
    whatsappMessage: 'Hi, I came from your website and I\'m interested in Chat Consultation'
  },
  {
    id: 2,
    title: 'Call Consultation',
    duration: '30 Minutes',
    price: CALL_CONSULTATION_PRICE,
    icon: Phone,
    badge: 'POPULAR',
    description: 'In-depth voice consultation for detailed discussion. Direct conversation with expert guidance.',
    features: ['Tarot Reading', 'Numerology Insights', 'Career & Marriage Guidance'],
    whatsappMessage: 'Hi, I came from your website and I\'m interested in Call Consultation'
  },
  {
    id: 3,
    title: 'Premium Session',
    duration: '60 Minutes',
    price: PREMIUM_SESSION_PRICE,
    icon: Star,
    badge: 'VIP',
    description: 'Complete life analysis with comprehensive guidance. Deep dive into all aspects of your destiny.',
    features: ['Full Tarot Spread', 'Complete Numerology', 'Life Path Analysis', 'Powerful Remedies'],
    whatsappMessage: 'Hi, I came from your website and I\'m interested in Premium Session'
  }
];

export const ConsultationServices = () => {
  const handleBookNow = (message) => {
    openWhatsApp(message);
  };

  return (
    <section className="py-20 sm:py-28 bg-gradient-to-b from-[#1A0B0C] to-[#0A0000] relative">
      {/* Background Texture */}
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/174d3dc0-fc62-4218-9cf1-1e8c201ee567/images/6cc817f4bfb2bcef42eb40d0288fe34c4380b0d2b1a6a520df64d1180dde5d37.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />

      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        {/* Section Label */}
        <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] text-center mb-4 font-light">
          CONSULTATION SERVICES
        </p>

        <h2 className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-snug font-medium text-center text-white mb-3">
          Personalized Consultation Sessions
        </h2>

        <p className="text-center text-[#A89B8C] mb-12 text-sm max-w-2xl mx-auto">
          Get direct guidance with expert consultation including Tarot Reading, Numerology Insights, Life Predictions & Personalized Remedies
        </p>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {consultationServices.map((service) => (
            <ConsultationCard key={service.id} service={service} onBook={handleBookNow} />
          ))}
        </div>

        {/* Bottom Note */}
        <p className="text-center text-[#A89B8C] text-xs mt-10">
          💬 All sessions include expert guidance with personalized remedies and insights
        </p>
      </div>
    </section>
  );
};
